var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"login-page",attrs:{"size":"thin"}},[(_vm.checkingLogin)?_c('div',{staticClass:"login-page__loading"},[_c('logo-loading')],1):_c('auth-box')],1)}
var staticRenderFns = []

export { render, staticRenderFns }